module.exports = "pegasus_template/assets/triple-card.png";